export const tr = {
    action: 'İşlemler'
};
